<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-row v-if="item" class="py-2">
        <b-col class="h-100">
            <b-row class="h-100">
                <b-col md="2">
                    <img @error="$event.target.style.display='none'" class="card-img-top"
                         :src="imageResource(thumbnail, 100)" alt="image"/>
                </b-col>
                <b-col md="10">
                    <b-row>
                        <b-col>
                            <b-row class="my-2">
                                <b-col class="article-name">
                                    {{item.articleDetails.primaryDescription ||
                                    item.articleDetails.secondaryDescription}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <small>{{item.articleDetails.name}}</small>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <small>{{customerArticleNumber}}</small>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="my-2">
                            <small>{{item.comment}}</small>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>

    import ArticleBase from "../Article/ArticleBase";

    export default {
        name: 'sample-checkout-item',
        extends: ArticleBase,
        props: {
            item: Object
        },
        components: {},
        data() {
            return {
                selectedColor: null,
                selectedSize: null
            };
        },
        created() {
            this.comment = this.item.comment;
        },
        computed: {
            article: function () {
                return this.item.articleDetails;
            },
            thumbnail: function () {
                let variant = this.variantList.find(variation => {
                    return variation.variationId == this.item.variantId;
                });

                let variantThumbnail = this.getThumbnail(variant.articleSize.id, variant.articleColor.id);
                return variantThumbnail ? variantThumbnail.media : (this.article.webImage || this.article.image);
            },
            articleDetails: function () {
                return this.item.articleDetails;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    img {
        height: 100%;
        max-height: 194px;
        width: 100%;
        margin: auto;
        object-fit: contain;
    }
</style>
